import axios from "axios";
import { toastr } from "react-redux-toastr";

import { closeModal, openModal } from "./modalAction";

import {
  // FETCH_DWK_PROPRESIS,
  FETCH_DWK_PROPRESI,
  SEARCH_DWK_PROPRESIS,
  FETCHING_DWK_PROPRESIS,
  MESSAGE,
} from "./types";

//search  PropResis SALE for ADMIN

export const searchPropResiSales =
  (values, limitRS, offsetRS) => async (dispatch) => {
    try {
      const res = await axios.post("/api/dwk/PropResiSaleSearch", {
        values,
        limitRS,
        offsetRS,
      });

      dispatch({ type: SEARCH_DWK_PROPRESIS, payload: res.data });
      dispatch({ type: FETCHING_DWK_PROPRESIS, payload: { fetchingRS: false } });
      dispatch(closeModal());
    } catch (error) {
      console.log("error_propresiSales", error);
      toastr.error(
        "Oops",
        "Something went wrong.Please Try Again searchPropResiSales"
      );
    }
  };

//*****************
//search  PropResis RENT

export const searchPropResiRents =
  (values, limitRR, offsetRR) => async (dispatch) => {
    try {
      const res = await axios.post("/api/dwk/PropResiRentSearch", {
        values,
        limitRR,
        offsetRR,
      });

      dispatch({ type: SEARCH_DWK_PROPRESIS, payload: res.data });
      dispatch({ type: FETCHING_DWK_PROPRESIS, payload: { fetchingRR: false } });
      dispatch(closeModal());
    } catch (error) {
      toastr.error(
        "Oops",
        "Something went wrong.Please Try Again searchPropResiRents"
      );
    }
  };

//fetch single PropResi
export const fetchPropResi = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/dwk/PropResiDetail/${id}`);

    dispatch({ type: FETCH_DWK_PROPRESI, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again_fetchPropResi");
  }
};

// create PropResi
export const createPropResi = (values, history) => async (dispatch) => {
  try {
    const res = await axios.post("/api/dwk/PropResiCreate", {
      values,
    });

    dispatch({ type: MESSAGE, payload: res.data });
    if (values.propertyFor === "SALE") {
      history.push("/dwk/propresi/PropResiSaleSearchList");
    } else {
      history.push("/dwk/propresi/PropResiRentSearchList");
    }

    dispatch(openModal("MessageModal"));
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
//resetOffset

export const resetOffsetPropResis = () => async (dispatch) => {
  try {
    dispatch({
      type: SEARCH_DWK_PROPRESIS,
      payload: { offsetRS: 0, offsetRR: 0, offsetRF: 0 },
    });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
//reset PropResiSale
export const resetPropResi = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DWK_PROPRESI, payload: null });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

// ****
export const resetLoadingPropResiSale = () => async (dispatch) => {
  try {
    dispatch({
      type: FETCHING_DWK_PROPRESISALES,
      payload: {
        fetching: true,
        noEntry: false,
      },
    });
    dispatch({
      type: SEARCH_DWK_PROPRESISALES,
      payload: {
        propresiSales: [],
        propresiSalesMy: [],
      },
    });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
// ****
export const resetNoEntryPropResiSale = () => async (dispatch) => {
  try {
    dispatch({
      type: FETCHING_DWK_PROPRESISALES,
      payload: {
        noEntry: false,
      },
    });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
